import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Mission from '../Mission';
import Footer from '../Footer';



export default function MissionStatement() {
  return (
    <>
      <HeroSection text1='MISSION STATEMENT' video='/videos/video-1.mp4'/>
      <Mission/>
      <Footer />
    </>
)
}